<template>
  <div class="type-nav">
    <div class="container">
      <div class="nav-left" @mouseleave="hideSort">
        <h2 class="all"  @mouseenter="isShowSort = true">全部商品分类</h2>
        <div class="sort animate__animated" v-show="isShowSort">
          <div class="all-sort-list2" @click.prevent="toSearch">
            <!-- 一级分类（一个item就是一个一级分类） -->
            <div class="item" v-for="c1 in categoryList.slice(0,15)" :key="c1.categoryId">
              <h3>
                <a data-level="1" :data-id="c1.categoryId" href="">{{c1.categoryName}}</a>
              </h3>
              <div class="item-list clearfix">
                <div class="subitem">
                  <!--二级分类（一个dl就是一个二级分类）  -->
                  <dl class="fore" v-for="c2 in c1.categoryChild" :key="c2.categoryId">
                    <dt>
                      <a data-level="2" :data-id="c2.categoryId" href="">{{c2.categoryName}}</a>
                    </dt>
                    <dd>
                      <!-- 三级分类（一个em就是一个三级分类） -->
                      <em v-for="c3 in c2.categoryChild" :key="c3.categoryId">
                        <a data-level="3"  :data-id="c3.categoryId" href="">{{c3.categoryName}}</a>
                      </em>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <nav class="nav">
        <a href="###">服装城</a>
        <a href="###">美妆馆</a>
        <a href="###">尚品汇超市</a>
        <a href="###">全球购</a>
        <a href="###">闪购</a>
        <a href="###">团购</a>
        <a href="###">有趣</a>
        <a href="###">秒杀</a>
      </nav>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import 'animate.css'

  export default {
    name: "TypeNav",
    data() {
      return {
        isShowSort:this.$route.path === '/home'
      }
    },
    methods: {
      // 点击一级分类、二级分类、三级分类的回调 —— 跳转搜索路由
      toSearch(event){
        // 获取点击分类的：level（级别）、id（编号）、innerText（名称）
        const {dataset:{id,level},innerText} = event.target
        // 判断点击的是否为分类链接
        if(level){
          // 跳转路由前先去尝试获取一下之前的关键词
          const {keyword} = this.$route.query
          // 跳转路由
          this.$router.push({
            path:'/search',
            // 跳转的同时携带query参数
            query:{
              [`category${level}Id`]:id,
              categoryName:innerText,
              keyword
            }
          })
          // 让下拉框隐藏
          this.isShowSort = false
        }
      },
      // 鼠标移除时隐藏下拉框的糊掉
      hideSort(){
        if(this.$route.path !== '/home'){
          this.isShowSort = false
        }
      }
    },
    computed:{
      ...mapState('home',['categoryList'])
    },
    mounted() {
      // 组件一挂载就立刻去联系一个action(服务员)去获取三级分类信息
      this.$store.dispatch('home/getCategoryList')
    },
  };
</script>

<style lang="less" scoped>
.type-nav {
  border-bottom: 2px solid #e1251b;

  .container {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    position: relative;

    .all {
      width: 210px;
      height: 45px;
      background-color: #e1251b;
      line-height: 45px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
    }

    .nav {
      a {
        height: 45px;
        margin: 0 22px;
        line-height: 45px;
        font-size: 16px;
        color: #333;
      }
    }

    .sort {
      position: absolute;
      left: 0;
      top: 45px;
      width: 210px;
      height: 461px;
      position: absolute;
      background: #fafafa;
      z-index: 999;
      animation-duration: 0.5s;

      .all-sort-list2 {
        .item {
          h3 {
            line-height: 30px;
            font-size: 14px;
            font-weight: 400;
            overflow: hidden;
            padding: 0 20px;
            margin: 0;
            &:hover {
              background-color: #ea4a36;
              a {
                color: white;
                text-decoration: none;
              }
            }

            a {
              color: #333;
            }
          }

          .item-list {
            display: none;
            position: absolute;
            width: 734px;
            min-height: 460px;
            background: #f7f7f7;
            left: 210px;
            border: 1px solid #ddd;
            top: 0;
            z-index: 9999 !important;

            .subitem {
              float: left;
              width: 650px;
              padding: 0 4px 0 8px;
              a {
                &:hover{
                  color: #ea4a36;
                  text-decoration: none;
                }
              }

              dl {
                border-top: 1px solid #eee;
                padding: 6px 0;
                overflow: hidden;
                zoom: 1;

                &.fore {
                  border-top: 0;
                }

                dt {
                  float: left;
                  width: 68px;
                  line-height: 22px;
                  text-align: right;
                  padding: 3px 6px 0 0;
                  font-weight: 700;
                }

                dd {
                  float: left;
                  width: 415px;
                  padding: 3px 0 0;
                  overflow: hidden;

                  em {
                    float: left;
                    height: 14px;
                    line-height: 14px;
                    padding: 0 8px;
                    margin-top: 5px;
                    border-left: 1px solid #ccc;
                  }
                }
              }
            }
          }

          &:hover {
            .item-list {
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>